import {useAppDispatch} from "@/lib/store.ts";
import {uuid} from "@/interfaces";
import {useEffect} from "react";
import {ChatService} from "@/services/chat.service.ts";
import {updateUnreadCount} from "@/app/user/messages/messages.slice.ts";

export function useResetUnread(roomId?: uuid | null) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!roomId) return;

        async function reset() {
            if (!roomId) return;
            await ChatService.resetUnread(roomId);
            dispatch(updateUnreadCount({ roomId, count: 0 }));
        }
        reset().catch((error) => {
            console.error("Failed to reset unread count:", error);
        });
    }, [dispatch, roomId]);
}
